import { i18n } from '@fs/zion-locale'

export const disabledStatuses = ['UPLOADING', 'ANALYZING', 'MATCHING', 'ERROR']

/* eslint-disable sonarjs/no-duplicate-string -- It is fine to duplicate translation keys */
export const treeStatusKeyMap = {
  MATCH_COMPLETE: 'tree-import.upload-trees.status.MATCH_COMPLETE',
  UPLOADING: 'tree-import.upload-trees.status.UPLOADING',
  UPLOADED: 'tree-import.upload-trees.status.UPLOADED',
  ANALYZING: 'tree-import.upload-trees.status.ANALYZING',
  MATCHING: 'tree-import.upload-trees.status.MATCHING',
  ADD_COMPLETE: 'tree-import.upload-trees.status.ADD_COMPLETE',
  ERROR: 'tree-import.upload-trees.status.ERROR',
}
// Based on https://beta.familysearch.org/service/tree/gedcom/upload/json_FileStatus.html
export const cetStatusKeyMap = {
  UNKNOWN: 'tree-import.upload-trees.status.ERROR',
  INITIATED: 'tree-import.upload-trees.status.UPLOADING',
  UPLOADING: 'tree-import.upload-trees.status.UPLOADING',
  FAILED_UPLOAD: 'tree-import.upload-trees.status.ERROR',
  PROCESSING: 'tree-import.upload-trees.status.UPLOADING',
  FAILED_PROCESSING: 'tree-import.upload-trees.status.ERROR',
  PROCESSED: 'tree-import.upload-trees.status.UPLOADED',
  IMPORTING: 'tree-import.upload-trees.status.IMPORTING',
  FAILED_IMPORT: 'tree-import.upload-trees.status.ERROR',
  IMPORTED: 'tree-import.upload-trees.status.IMPORTED',
  FAILED_DELETE: 'tree-import.upload-trees.status.ERROR',
  UPLOADED: 'tree-import.upload-trees.status.UPLOADED',
  READY: 'tree-import.upload-trees.status.READY',
  MATCH_COMPLETE: 'tree-import.upload-trees.status.MATCH_COMPLETE',
  ERROR: 'tree-import.upload-trees.status.ERROR',
}
/* eslint-enable sonarjs/no-duplicate-string -- re-enable */

export const dateTimeFormatter = new Intl.DateTimeFormat(i18n.language, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})

export const formatDate = (date) => dateTimeFormatter.format(new Date(date))

const units = ['bytes', 'KB', 'MB', 'GB']

// https://stackoverflow.com/a/39906526
export function niceBytes(x) {
  let l = 0
  let n = parseInt(x, 10)
  while (n >= 1024 && ++l) {
    n /= 1024
  }
  // include a decimal point and a tenths-place digit if presenting
  // less than ten of KB or greater units
  return `${n.toFixed(n < 10 && l > 0 ? 1 : 0)} ${units[l]}`
}
